import { ObjectValues } from 'types';

export const HORIZONTAL_POSITION = {
  RIGHT: 'right',
  LEFT: 'left',
} as const;

export const VERTICAL_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
} as const;

export const POSITION = { ...HORIZONTAL_POSITION, ...VERTICAL_POSITION };

export type HorizontalPosition = ObjectValues<typeof HORIZONTAL_POSITION>;
export type VerticalPosition = ObjectValues<typeof VERTICAL_POSITION>;
export type Position = ObjectValues<typeof POSITION>;
